// Date formats
export const NO_YEAR_DATE_FORMAT = 'D MMM'; // 1 Jan
export const TWO_DIGITS_YEAR_DATE_FORMAT = 'D MMM YY'; // 1 Jan 21
export const FOUR_DIGITS_YEAR_DATE_FORMAT = 'D MMM YYYY'; // 1 Jan 2021

export const FP_NO_YEAR_DATE_FORMAT = 'j M';
export const FP_DATE_FORMAT = 'j M y'; // 1 Jan 21

export const DAYJS_NO_YEAR_DATE_FORMAT = 'D MMM';

export const FLATPICKR_OPTIONS = {
  wrap: true, // Custom elements and input groups
  mode: 'range',
  clickOpens: false,
  dateFormat: FP_NO_YEAR_DATE_FORMAT, // 1 Jan
  minDate: 'today',
  enableTime: false,
  monthSelectorType: 'static', // Month displayed in the header of the calendar.
};
